define('viewModels/privileged/base/BaseTemplateEditorSetup',[
    'lib/knockout',
    'util/errorCallbackFactory',
    'viewModels/ViewModel',
    'viewModels/privileged/base/BaseTemplateEditor'
], function (ko, errorCallbackFactory, ViewModel, BaseTemplateEditor) {
    'use strict';

    var BaseTemplateEditorSetup = ViewModel.extend(function () {
        var self = this;

        /**
         * This will be true if this is a new entity.
         */
        self.isNew = ko.observable(true);

        /**
         * The type of template entity that is being configured.
         */
        self.configEntityType = ko.observable(null);

        /**
         * The config service to use for the config entity type.
         */
        self.configService = null;

        /**
         * A list of all the schemas for this entity.
         */
        self.schemaList = ko.observableArray();

        /**
         * The currently selected schema.
         */
        self.selectedSchema = ko.observable(null);

        /**
         * The loading state for the list of entity schemas.
         */
        self.loadingSchemaList = ko.observable(false);

        /**
         * The template instance (if it already exists).
         */
        self.template = ko.observable(null);

        /**
         * The loading state for the template instance.
         */
        self.loadingTemplate = ko.observable(false);

        /**
         * The constructor for the editor.
         */
        self.editorConstructor = BaseTemplateEditor;

        /**
         * First class config properties.
         */
        self.name = ko.observable('');

        /**
         * Validation for the first class config properties.
         */
        self.name.extend({ required: true });
        self.errors = ko.validation.group([self.name]);
        self.errors.showAllMessages();

        /**
         * Loads a complete list of all the schemas for this entity.
         */
        self.loadSchemaList = function () {
            self.loadingSchemaList(true);
            return this.configService.listSchemas()
                .then(function (response) {
                    self.schemaList(response.entities);
                    return response;
                })
                .catch(errorCallbackFactory.createCallback({ namespace: 'config.error' }))
                .finally(function () {
                    self.loadingSchemaList(false);
                });
        };

        /**
         * Load a specific template for updating.
         */
        self.loadTemplate = function (templateUri) {
            self.isNew(false);
            self.loadingTemplate(true);
            return this.configService.readTemplate(templateUri)
                .then(function (response) {
                    self.selectedSchema(response.schema.selfUri.toLowerCase());
                    self.template(response.selfUri);
                    self.name(response.name);
                    return response;
                })
                .catch(errorCallbackFactory.createCallback({ namespace: 'config.error' }))
                .finally(function () {
                    self.loadingTemplate(false);
                });
        };

        /**
         * An editor instance initialized correctly.
         */
        self.editorView = self.computed(function () {
            var editor;

            // configure the editor to create a new template from a schema.
            if (self.isNew() && self.configEntityType() && self.selectedSchema()) {
                editor = self.subView(self.editorConstructor);
                editor.configure({
                    setup: self,
                    configEntityType: self.configEntityType(),
                    schemaUri: self.selectedSchema()
                });
                return editor;
            }

            // Configure the editor for updating an existing template.
            else if (self.configEntityType() && self.template()) {
                editor = self.subView(self.editorConstructor);
                editor.configure({
                    setup: self,
                    configEntityType: self.configEntityType(),
                    templateUri: self.template()
                });
                return editor;
            }

            return null;
        });

        /**
         * Configures this ViewModel.
         */
        self.configure = function (options) {
            options = options ? options : {};
            self.isNew(true);

            self.configEntityType(options.configEntityType);

            // Set the editor instance constructor.
            if (options.editorConstructor) {
                self.editorConstructor = options.editorConstructor;
            }

            // Load the complete list of schemas.
            self.loadSchemaList()
                .then(function () {

                    // If a template URI is passed in then we are updating an existing template.
                    if (options.templateUri) {
                        self.loadTemplate(options.templateUri);
                    }
                });
        };

        /**
         * Determines if all the fields are valid.
         */
        self.isValid = self.computed(function () {
            return self.errors().length === 0;
        });
    });

    return BaseTemplateEditorSetup;
});

